import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_auth/settings/intake/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { hasPagePermission } = useUser();
  const firstAccessiblePath = [
    [
      PAGE_PERMISSION_KEYS.intakeSettingsLeadSources,
      "/settings/intake/lead-sources",
    ],
    [PAGE_PERMISSION_KEYS.intakeSettingsRoles, "/settings/intake/roles"],
    [PAGE_PERMISSION_KEYS.intakeSettingsTeams, "/settings/intake/teams"],
    [PAGE_PERMISSION_KEYS.intakeSettingsTypes, "/settings/intake/matter-types"],
    [PAGE_PERMISSION_KEYS.intakeSettingsStatuses, "/settings/intake/statuses"],
    [PAGE_PERMISSION_KEYS.intakeSettingsTags, "/settings/intake/tags"],
    [
      PAGE_PERMISSION_KEYS.intakeSettingsTaskPlans,
      "/settings/intake/task-plans",
    ],
  ].find(([permissionId]) => hasPagePermission(permissionId))?.[1];

  useEffect(() => {
    if (firstAccessiblePath) {
      void navigate({ to: firstAccessiblePath, replace: true });
    }
  }, [firstAccessiblePath, navigate]);

  if (!firstAccessiblePath) {
    return <GlobalNotAuthorized />;
  }

  return null;
}
